/**
 * Address 业务模型：省市区地址拼接等通用逻辑
 * 作为 tbs.model.mo 下的通用业务模块，供 vo 或各业务场景复用
 */
var tbs_model_mo_Address = function () {}

tbs_model_mo_Address.prototype = {
  /**
   * 省市区拼接为展示用地址
   * 1. 优先使用 district、city（最后两级）
   * 2. district 为空时用 city、province
   * 3. 相邻两级相同时只保留一级
   * @param {string} province - 省
   * @param {string} city - 市
   * @param {string} district - 区
   * @param {string} [separator='·'] - 拼接符号
   * @return {string}
   */
  renderAddress: function (province, city, district, separator) {
    separator = separator !== undefined && separator !== null ? String(separator) : '·'
    province = province || ''
    city = city || ''
    district = district || ''

    var result = []
    if (district) {
      if (city) {
        if (city === district) result.push(district)
        else result.push(city, district)
      } else result.push(district)
    } else {
      if (city && province) {
        if (province === city) result.push(city)
        else result.push(province, city)
      } else if (city) result.push(city)
      else if (province) result.push(province)
    }
    return result.join(separator)
  }
}

var instance
if (!instance) instance = new tbs_model_mo_Address()
module.exports = instance
